export const dogUrlGenerator = (name) => {
    // console.log(name)
    return name.replaceAll(' ', '-').toLowerCase().replaceAll('/', '-')
}